import React from "react";

export const GameScore = (props: GameScoreProps) => {
	if (props.gameScore == null) {
		return (
			<div className="offer__score__col offer__score__game¨is-empty" />
		);
	}

	return (
		<div className="offer__score__col offer__score__game">
			<div className="offer__score__item">
				{props.gameScore.home || 0}
			</div>
			<div className="offer__score__item">
				{props.gameScore.away || 0}
			</div>
		</div>
	);
};

type GameScoreProps = {
	gameScore:
		| {
				home: string;
				away: string;
		  }
		| undefined;
};
